// Shared by the "Terminate" form, the termination summary on the employee
// profile and the "Notify" dialog.

// Same keys as the server's `terminationReasonEnums`.
export const TERMINATION_REASON_KEYS = [
  'MUTUAL_AGREEMENT',
  'EMPLOYEE_RESIGNATION',
  'EMPLOYER_DISMISSAL',
  'FIXED_TERM_EXPIRY',
  'RETIREMENT',
  'OTHER',
];

export const TERMINATION_REASON_NOTE_MAX_LENGTH = 300;

export const terminationQueryKey = (employeeId) => [
  'employee-termination',
  employeeId,
];

// The form's "Document" select holds one value for three kinds of choice.
export const DOCUMENT_BUILTIN = 'builtin';
export const DOCUMENT_NONE = 'none';
const TEMPLATE_PREFIX = 'template:';

export const templateDocumentValue = (templateId) =>
  `${TEMPLATE_PREFIX}${templateId}`;

/** `{ documentChoice, documentTemplateId? }` the server expects. */
export const parseDocumentValue = (value) => {
  if (typeof value === 'string' && value.startsWith(TEMPLATE_PREFIX)) {
    return {
      documentChoice: 'template',
      documentTemplateId: value.slice(TEMPLATE_PREFIX.length),
    };
  }
  return { documentChoice: value === DOCUMENT_NONE ? 'none' : 'builtin' };
};

/**
 * Templates HR may pick as the termination's document: the company's active
 * employee templates, as the custom-document form offers them, without the
 * contract/annex ones (those write a new employment contract).
 */
export const terminationDocumentTemplates = (templates = []) =>
  templates.filter((tpl) => !tpl.contractKind && tpl.status !== 'archived');

/**
 * Today's default: the company template bound to terminations that replaces
 * the built-in decision, else the built-in decision.
 */
export const defaultDocumentValue = (templates = []) => {
  const replacing = terminationDocumentTemplates(templates).find(
    (tpl) =>
      tpl.autoGenerateOnLeaveType === 'termination' &&
      tpl.replacesDefaultDocument
  );
  return replacing ? templateDocumentValue(replacing._id) : DOCUMENT_BUILTIN;
};

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const isValidEmail = (value) =>
  EMAIL_PATTERN.test(String(value || '').trim());
